'use strict';
import DomUtils from 'helpers/dom-utils';
import Events from 'events/events';

import closeButtonTemplate from 'components/buttons/button-close/button-close.hbs';
import tooltipButtonTemplate from 'components/tooltips/button-tooltip/button-tooltip.hbs';

function createToolTip(toolTipContent) {
  toolTipContent.classList.add('is-closed');
  toolTipContent.setAttribute('aria-expanded', false);

  let closeButton = DomUtils.createElementsFromString(closeButtonTemplate({notificationCloseText: 'Close tooltip information'}))[0];
  closeButton.addEventListener('click', function(){ closeContent(tooltipData); });
  toolTipContent.appendChild(closeButton);

  let tooltipButton = DomUtils.createElementsFromString(tooltipButtonTemplate({tooltipText: 'Read tooltip information'}))[0];
  const isChanel = document.querySelector('.chanel-product-page-main');
  if(isChanel) tooltipButton.classList.add('button-tooltip__chanel');

  let tooltipData = toolTipContent.getAttribute('data-tooltip');
  if(tooltipData){
    document.getElementById(tooltipData).appendChild(tooltipButton);
    tooltipButton.setAttribute('data-tooltip', tooltipData);
    tooltipButton.addEventListener('click', function( event ){ toggleContent( event, toolTipContent, tooltipData ); });
  }
}

function toggleContent(event, toolTipContent, tooltipData) {
  event.preventDefault();
  if (toolTipContent.getAttribute('data-tooltip') == tooltipData && toolTipContent.classList.contains('is-closed')) {
    openTooltipContent(tooltipData);
  } else {
    closeTooltipContent(tooltipData);
  }
}

function closeContent(tooltipData) {
  closeTooltipContent(tooltipData);
}

function openTooltipContent(tooltipData) {
  let toolTipContents = document.querySelectorAll('.tooltip-content');

  for (let toolTipContent of toolTipContents) {

    if(toolTipContent.getAttribute('data-tooltip') == tooltipData){

      toolTipContent.setAttribute('aria-expanded', true);

      toolTipContent.classList.remove('is-closed');
      toolTipContent.classList.add('is-open');
      Events.accordionWillAdjustHeight.trigger(document);
    }
  }
}

function closeTooltipContent(tooltipData) {
  let toolTipContents = document.querySelectorAll('.tooltip-content');

  for (let toolTipContent of toolTipContents) {

    if(toolTipContent.getAttribute('data-tooltip') == tooltipData){

      toolTipContent.setAttribute('aria-expanded', false);

      toolTipContent.classList.remove('is-open');
      toolTipContent.classList.add('is-closed');
      Events.accordionWillAdjustHeight.trigger(document);
    }
  }
}

function init( request ) {

  let toolTipContent = document.querySelector('.tooltip-content');

  if(toolTipContent){

    let toolTipContentBlocks;

    if( request && request === 'basket-form' ) {
      toolTipContentBlocks = document.querySelectorAll('.add-to-basket-form .tooltip-content');
    } else {
      toolTipContentBlocks = document.querySelectorAll('.tooltip-content');
    }

    for (let toolTipContentBlock of toolTipContentBlocks) {
      new createToolTip(toolTipContentBlock);
    }
  }
}

if ('querySelector' in document) {
  init();
  Events.tooltipsReinit.register(init);
}

export default init;
